export const actionTypes = {
    DISCONNECT_ENVIRONMENT_SENSOR_SETTINGS: 'powertrainTools/gatewayManagement/DISCONNECT_ENVIRONMENT_SENSOR_SETTINGS',
    DISCONNECT_ENVIRONMENT_SENSOR: 'powertrainTools/gatewayManagement/DISCONNECT_ENVIRONMENT_SENSOR'
};
